import React from 'react';
import styles from './TabBar.module.css';

/**
 * TabBar — barra de pestañas superior.
 *
 * @param {Array}    tabs        - Lista de { id, label, fn }
 * @param {string}   activeId    - ID de la pestaña activa
 * @param {Function} onSelect    - Callback al seleccionar pestaña
 */
function TabBar({ tabs, activeId, onSelect }) {
  return (
    <nav className={styles.bar} aria-label="Ejercicios">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`${styles.tab} ${activeId === tab.id ? styles.active : ''}`}
          onClick={() => onSelect(tab.id)}
          aria-current={activeId === tab.id ? 'page' : undefined}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}

export default TabBar;
